import { B } from "./blocks.js";
import { hash2 } from "./util.js";
import { REGION, homeRegion } from "./discovery-terrain.js";
// Region-clipped and deterministic: every entrance descends one block per step.
export function carveExpansion(w, rx, rz) {
  const x0 = rx * REGION,
    z0 = rz * REGION;
  if (!homeRegion(rx, rz)) {
    for (let x = 2; x < 30; x++)
      for (let z = 3; z < 30; z++)
        for (let y = 12; y <= 30; y++) {
          const tunnel =
            Math.abs(y - (21 + Math.sin((x + x0) * 0.13) * 3)) < 2.4 &&
            Math.abs(z - (22 + Math.sin((x + x0) * 0.18) * 3)) < 3;
          const chamber =
            ((x - 26) / 5) ** 2 + ((z - 25) / 5) ** 2 + ((y - 25) / 5) ** 2 < 1;
          if (tunnel || chamber) w.set(x0 + x, y, z0 + z, B.AIR);
        }
    for (let i = 0; i <= 19; i++) {
      const x = x0 + 5 + i,
        y = 40 - i;
      for (let z = z0 + 24; z <= z0 + 26; z++) {
        w.set(x, y, z, B.STONE_BRICK);
        w.fill(x, y + 1, z, x, Math.max(y + 4, i < 4 ? 48 : y + 4), z, B.AIR);
      }
      if (i % 4 === 0) {
        w.set(x, y + 1, z0 + 23, B.TORCH);
        w.fill(x, y + 1, z0 + 27, x, y + 3, z0 + 27, B.LOG);
      }
    }
    w.fill(x0 + 24, 21, z0 + 21, x0 + 29, 21, z0 + 29, B.STONE_BRICK);
    w.fill(x0 + 24, 22, z0 + 21, x0 + 29, 26, z0 + 29, B.AIR);
    for (const [x, z, id] of [
      [25, 21, B.COAL_ORE],
      [27, 21, B.IRON_ORE],
      [29, 24, B.CRYSTAL],
      [29, 25, B.DIAMOND_ORE],
      [25, 28, B.CRYSTAL],
    ])
      w.set(x0 + x, 22, z0 + z, id);
    w.set(x0 + 26, 26, z0 + 25, B.GLOWSTONE);
    w.set(x0 + 28, 22, z0 + 28, B.CHEST);
  }
  // Two sky gardens, separate from the ground: arrival/flight destinations.
  if ((rx === 1 && rz === 1) || (rx === 3 && rz === 1)) {
    for (let x = 8; x <= 24; x++)
      for (let z = 8; z <= 24; z++) {
        const dist = Math.hypot(x - 16, z - 16);
        if (dist > 8) continue;
        for (let y = 68 - Math.floor((8 - dist) * 0.6); y <= 68; y++)
          w.set(x0 + x, y, z0 + z, y === 68 ? B.GRASS : B.CRYSTAL);
        if (hash2(x, z, 14) > 0.88) w.set(x0 + x, 69, z0 + z, B.FLOWER_BLUE);
      }
    w.fill(x0 + 13, 69, z0 + 20, x0 + 13, 73, z0 + 20, B.PORTAL_FRAME);
    w.fill(x0 + 17, 69, z0 + 20, x0 + 17, 73, z0 + 20, B.PORTAL_FRAME);
    w.fill(x0 + 13, 73, z0 + 20, x0 + 17, 73, z0 + 20, B.PORTAL_FRAME);
  }
}
